module.exports = __webpack_public_path__ + "images/apple-touch-icon.229ecc275227d0c030ff67e211a586c4.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/favicons/apple-touch-icon.png
// module id = 997
// module chunks = 0